'use client';
import React, { useEffect, useState, useRef } from 'react';
import { TiArrowForward } from 'react-icons/ti';
import Image from 'next/image';
import './Specialities.css'
const specialitiesData = [
  {
    id: 1,
    title: 'Interventional Cardiology',
    image: '/images/icons/orange_cardiology.webp',
    contentImage: 'https://cdn.dotplus.in/Cloud/Aarogyam/home/Our_Specialities/cardiology1.jpg?width=490',
    description: `Cardiology is the medical specialty focused on diagnosing and treating heart and cardiovascular diseases. Cardiologists use various techniques, including echocardiography and stress testing, to assess heart health and develop personalized treatment plans. With ongoing research and advancements, cardiology continues to play a crucial role in improving heart health and patient outcomes.`,
    pointsLeft: [
      'Heart Failure Clinic',
      'Angiography',
      'Angioplasty',
      'Primary Angioplasty',
    ],
    pointsRight: [
      'Temporary Pacemaker',
      'Permanent Pacemaker',
      'CRT-D, ROTABLATOR & IVUS',
      'Balloon Mitral Valvuloplasty',
    ],
  },
  {
    id: 2,
    title: 'Cardiothoracic & Vascular Surgery',
    image: '/images/icons/orange_Cardiothoracic.webp',
    contentImage: 'https://cdn.dotplus.in/Cloud/Aarogyam/home/Our_Specialities/Cardiothoracic-Vascular-Surgery.jpg?width=490',
    description: 'Cardiothoracic and vascular surgery involves the diagnosis and treatment of conditions affecting the heart, lungs, and blood vessels. Surgeons in this specialty perform complex procedures, such as bypass surgery and valve repair, to improve patient outcomes. Advances in technology and techniques continue to enhance the effectiveness and safety of these life-saving interventions.',
    pointsLeft: [
      'CABG ( Coronary Artery Bypass Graft )',
      'Aortic Valve Surgery',
      'Thoracic Surgery',
      'Device Closure',
    ],
    pointsRight: [
      'Heart Volve Replacement Surgery',
      'ASD ( Autism Spectrum Disorder )',
      'VSD ( Ventricular Septal Defect )',
    ],
  },
  {
    id: 3,
    title: 'Nephrology',
    image: '/images/icons/orange_nephrology.webp',
    contentImage: 'https://cdn.dotplus.in/Cloud/Aarogyam/home/Our_Specialities/neurology.jpg?width=490',
    description: 'Nephrology is the medical specialty focused on diagnosing and treating kidney disorders and diseases. Nephrologists manage conditions such as chronic kidney disease, hypertension, and electrolyte imbalances through various interventions, including dialysis and transplantation. Advances in research and technology continue to enhance the understanding and treatment of renal health.',
    pointsLeft: [
      'Radical Nephrectomy',
      'Partial Nephrectomy',
      'Open Surgery',
    ],
    pointsRight: [
      'Laparoscopic Surgery',
      'Robot-assisted laparoscopic Surgery',
    ],
  },
  {
    id: 4,
    title: 'Neurology',
    image: '/images/icons/orange_neurology.webp',
    contentImage: 'https://cdn.dotplus.in/Cloud/Aarogyam/home/Our_Specialities/NewNeurology.jpg?width=490',
    description: 'Neurology is the medical specialty focused on diagnosing and treating disorders of the nervous system, including the brain, spinal cord, and nerves. Neurologists address conditions such as epilepsy, multiple sclerosis, and stroke through comprehensive evaluations and advanced imaging techniques. Ongoing research and innovations in treatment are vital for improving outcomes in patients with neurological disorders.',
    pointsLeft: [
      'Anterior Cervical Discectomy',
      'Chiari Decompression',
      'Laminectomy',
      'Vascular/Endovascular Neurosurgery',
      'Neurosurgical Oncology,'
    ],
    pointsRight: [
      'Spine Neurosurgery',
      'Functional Neurosurgery',
      'Pediatric Neurosurgery',
      'Peripheral Nerve Neurosurgery',
    ],
  },
  {
    id: 5,
    title: 'Urology',
    image: '/images/icons/orange_urology.webp',
    contentImage: 'https://cdn.dotplus.in/Cloud/Aarogyam/home/Our_Specialities/urology.jpg?width=490',
    description: 'Urology is the medical specialty dedicated to diagnosing and treating conditions related to the urinary tract and male reproductive system. Urologists manage a wide range of issues, including urinary infections, prostate disorders, and kidney stones. Advances in minimally invasive techniques have greatly improved patient outcomes and recovery times in this field.',
    pointsLeft: [
      'Bladder Stone Removal',
      'Circumcision',
      'Kladder for Cancer',
      'Kidney Stone Removal',
    ],
    pointsRight: [
      'Vasectomy',
      'Removal of the Prostate',
      'Reconstruction of the Bladder or Urethra',
      'Vasectomy Reversal',
    ],
  },
  {
    id: 6,
    title: 'Orthopedics & Joint Replacement',
    image: '/images/icons/orange_orthopedics.webp',
    contentImage: 'https://cdn.dotplus.in/Cloud/Aarogyam/home/Our_Specialities/Joint-replacement.jpg?width=490',
    description: 'Orthopedics and joint replacement focus on diagnosing and treating musculoskeletal conditions, including injuries and degenerative diseases. Orthopedic surgeons perform procedures such as hip and knee replacements to restore function and relieve pain. Advances in minimally invasive techniques and rehabilitation are improving patient outcomes and recovery times in this specialty.',
    pointsLeft: [
      'Knee Replacement',
      'Hip Replacement',
      'Shoulder Replacement',
      'Ankle Replacement',
      'Bone Grafting',
    ],
    pointsRight: [
      'Bone Reconstruction',
      'Cartilage Repair',
      'Cartilage Restoration',
      'Spinal Fusion',
      'Herniated Disc Surgery',
    ],
  },
];

const Specialities = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [isMobile, setIsMobile] = useState(false);
  const activeItem = specialitiesData.find(item => item.id === activeTab);
  const contentRef = useRef(null);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1199);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  return (
    <div className="specialities-wrapper container css-padding">
      <div className='title-section text-centre'>
        <p className='css-heading'>
          <span className='first-title'>Our</span>
          <span className='second-title'> Specialities</span>
        </p>
        <Image
          src="/images/DNA.webp"
          alt="DNA image"
          width={67}
          height={21}
      />
      </div>
      <div className="">
        {/* Desktop View */}
        {!isMobile && (
          <div className="tabs d-flex flex-wrap justify-content-between css-specialities-box desktop-tabs">
            {specialitiesData.map((item) => (
              <div
                key={item.id}
                className={`tab-item ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => setActiveTab(item.id)}
              >
                <div className="tab-icon mb-2">
                  <Image src={item.image} alt={item.title} width="40" height="40"  loading='lazy'/>
                </div>
                <div className="tab-title">
                  {item.title
                    .split(' ')
                    .map((word, i) =>
                      i % 2 === 0 ? word.toUpperCase() : word.toLowerCase()
                    )
                    .join(' ')}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Mobile View */}
        {isMobile && (
          <div className="mobile-tabs">
            {specialitiesData.map((item) => (
              <div
                key={item.id}
                className={`tab-item-mobile d-flex align-items-center mb-1 p-2 ${activeTab === item.id ? 'active' : ''}`}
                onClick={() => {
                  setActiveTab(item.id);
                  if (isMobile && contentRef.current) {
                    setTimeout(() => {
                      contentRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 100); // slight delay ensures content is rendered
                  }
                }}
              >
                <div className="tab-icon-circle d-flex align-items-center justify-content-center me-3">
                  <Image src={item.image} alt={item.title} width="30" height="30"  loading='lazy'/>
                </div>
                <div className="tab-title">{item.title}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      {activeItem && (
        <div ref={contentRef} className="speciality-content d-flex flex-wrap shadow-sm p-3 bg-white">
          {activeItem.contentImage && (
            <div className="css-speciality-left-img col-lg-5 col-12">
              <Image
                src={activeItem.contentImage}
                alt={activeItem.title}
                width={490}
                height={490}
                className="img-fluid"
                loading='lazy'
              />
            </div>
          )}
          <div className="css-speciality-right-text col-lg-7 col-12">
            <p className="css-specialities-heading">{activeItem.title}</p>
            <p>{activeItem.description}</p>
            <div className="d-flex css-specialities-list-mt">
              <ul className="list-unstyled css-left-list-mr">
                {activeItem.pointsLeft?.map((point, idx) => (
                  <li key={idx} className="check-mark text-dark d-flex align-items-start">
                    <TiArrowForward className="me-2 text-orange" size={18} />
                    {point}
                  </li>
                ))}
              </ul>
              <ul className="list-unstyled">
                {activeItem.pointsRight?.map((point, idx) => (
                  <li key={idx} className="check-mark text-dark d-flex align-items-start">
                    <TiArrowForward className="me-2 text-orange" size={18} />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Specialities;
